import { Component, Input } from "@angular/core";
import { EmptyComponentData } from "../../models/empty.model";
import { environment } from "../../../../environments/environment";

export enum EmptyMode {
  appointments = "appointments",
  favorites = "favorites",
  services = "services",
  users = "users",
  customerRelationship = "customer-relationship",
  promotions = "promotions",
  salons = "salons",
  reviews = "reviews",
  staff = "staff",
}

@Component({
  selector: "glo-empty",
  imports: [],
  templateUrl: "./empty.component.html",
  styleUrl: "./empty.component.scss",
})
export class EmptyComponent {
  @Input() showBtn: boolean = true;
  @Input() mode: EmptyMode | string = EmptyMode.appointments;

  assetUrl = environment.assetBaseUrl;

  data: Record<EmptyMode | string, EmptyComponentData> = {
    [EmptyMode.appointments]: {
      icon: "folder-big",
      title: "No upcoming appointments here",
      desc: "You can see all your orders here. Let's get your glo on!",
      buttonTitle: "Browse Now",
    },
    [EmptyMode.favorites]: {
      icon: "",
      title: "",
      desc: "",
      buttonTitle: "",
    },
    [EmptyMode.services]: {
      icon: "services-big",
      title: "No Services Added Yet",
      desc: "Start by adding your first service and make it easy for clients to book their next appointment.",
      buttonTitle: "Start Exploring",
    },
    [EmptyMode.users]: {
      icon: "services-big",
      title: "No Employees Added Yet",
      desc: "Efficiently manage your team by adding employees and tracking their roles and activities.",
    },
    [EmptyMode.customerRelationship]: {
      icon: "customer-rel-big",
      title: "No Customer Relationship Added Yet",
      desc: "Efficiently manage your team by adding employees and tracking their roles and activities.",
    },
    [EmptyMode.promotions]: {
      icon: "dicsount",
      title: "No Discounts Created Yet",
      desc: "Boost customer engagement by offering special discounts.",
    },
    [EmptyMode.salons]: {
      icon: "folder-big",
      title: "No salons available?",
      desc: "Tweak your search and find your glo.",
      buttonTitle: "Browse",
    },
    [EmptyMode.staff]: {
      icon: "folder-big",
      title: "No staff available",
      desc: "You can see all staff here. Once available!",
    },
    [EmptyMode.reviews]: {
      icon: "folder-big",
      title: "No reviews available",
      desc: "You can see all reviews here. Be the first one to review",
    },
  };
}
